import { throwApiError } from '@/shared/utils/apiResponse';
import { apiDelete, apiGet, apiPatch, apiPost } from '@/shared/utils/requestBuilder';

import type { CreatePendenciaInput, InternalChatPendencia } from '../../types';

const unwrap = <T>(body: unknown): T => {
  if (typeof body === 'object' && body !== null && 'data' in body) {
    return (body as { data: T }).data;
  }
  return body as T;
};

const jsonOk = async <T>(response: Response, fallbackMsg: string): Promise<T> => {
  if (!response.ok) await throwApiError(response, fallbackMsg);
  const body = (await response.json()) as unknown;
  return unwrap<T>(body);
};

export const pendenciasService = {
  list: async (params: {
    conversaId?: string;
    resolvida?: boolean;
  }): Promise<{ items: InternalChatPendencia[] }> => {
    const qp: Record<string, string | number | boolean> = {};
    if (params.conversaId) qp.conversaId = params.conversaId;
    if (params.resolvida !== undefined) qp.resolvida = params.resolvida;
    const response = await apiGet('/messaging/pendencias', qp);
    return jsonOk<{ items: InternalChatPendencia[] }>(response, 'Erro ao carregar pendências');
  },
  create: async (input: CreatePendenciaInput): Promise<InternalChatPendencia> => {
    const response = await apiPost('/messaging/pendencias', input);
    return jsonOk<InternalChatPendencia>(response, 'Erro ao criar pendência');
  },
  update: async (
    pendenciaId: string,
    input: {
      nome?: string;
      descricao?: string;
      resolvida?: boolean;
      lembreteEm?: string | null;
      mensagemId?: string | null;
    },
  ): Promise<InternalChatPendencia> => {
    const response = await apiPatch(`/messaging/pendencias/${pendenciaId}`, input);
    return jsonOk<InternalChatPendencia>(response, 'Erro ao atualizar pendência');
  },
  remove: async (pendenciaId: string): Promise<void> => {
    const response = await apiDelete(`/messaging/pendencias/${pendenciaId}`);
    if (!response.ok && response.status !== 204) {
      await throwApiError(response, 'Erro ao remover pendência');
    }
  },
};
